import React from "react";

const CONTEXT = React.createContext();

export function useDeviceStatusManager(){
    const context = React.useContext(CONTEXT);
    if (!context) {
        throw new Error("useDeviceStatusManager must be used within a DeviceStatusManager");
    }
    return context;
}

export function DeviceStatusManager({children}){
    const [type, setType] = React.useState("status");

    return <CONTEXT.Provider value={{type, setType}}>
        {children}
    </CONTEXT.Provider>
}